module.exports = __webpack_public_path__ + "static/media/email.80b9c47b.svg";